import VueRouter from 'vue-router'
import store from "./store";
import _ from "underscore";
import LoginView from './components/views/Login';
import ForgetPasswordView from "~/components/views/auth/ForgetPassword";
import ResetPasswordView from "~/components/views/auth/ResetPassword";
import SignupView from './components/views/Signup';
import ConfirmView from './components/views/Confirm';
import AdminView from './components/views/Admin';
import RegistrationView from './components/views/registration/Index';
import EventPollView from './components/views/event_poll/Index';
import EventPollListView from './components/views/event_poll/List';
import EventListView from './components/views/event/List';
import EventManageView from './components/views/event/Manage';
import ContactListView from './components/contact/List';
import ContactGroupView from './components/contact/Group';
import TeamListView from './components/team/List';
import UserDetailsView from './components/views/user/Details';
import AgentListView from './components/views/agent/List';
import MediaDisplay from './components/views/MediaDisplay'
import UnauthorizedView from './components/views/Unauthorized';
import PageNotFoundView from './components/views/PageNotFound';
import AuthHelper from "./utils/auth-helper";

const routes = [
    {
        path: '/',
        name: 'root',
        redirect: {
          name: 'public_login',
          params: {
              lang: 'en'
          }
        }
    },
    {
        path: '/:lang',
        component: {
            render (c) { return c('router-view') }
        },
        children: [
            {
                path: '/',
                name: 'subRoot',
                redirect: {
                    name: 'public_login'
                }
            },
            {
                path: 'vr',
                name: 'vr',
                meta: {requires_auth: false},
                component: MediaDisplay
            },
            {
                path: 'login',
                name: 'login',
                meta: { requires_auth: false,  public_login: false},
                component: LoginView
            },
            {
                path: 'public_login',
                name: 'public_login',
                meta: { requires_auth: false, public_login: true},
                component: LoginView
            },
            {
                path: 'forget_password',
                name: 'forget_password',
                meta: { requires_auth: false},
                component: ForgetPasswordView
            },
            {
                path: 'reset_password',
                name: 'reset_password',
                meta: { requires_auth: false},
                component: ResetPasswordView
            },
            {
                path: 'signup',
                name: 'signup',
                meta: { requires_auth: false },
                component: SignupView
            },
            {
                path: 'confirm',
                name: 'confirm',
                meta: { requires_auth: false },
                component: ConfirmView
            },
            {
                path: 'registration',
                name: 'registration',
                meta: { requires_auth: false },
                component: RegistrationView
            },
            {
                path: 'poll',
                name: 'poll',
                meta: { requires_auth: false },
                component: EventPollView
            },
            {
                path: 'event',
                meta: { requires_auth: true},
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: 'poll',
                        meta: { requires_auth: true},
                        component: {
                            render (c) { return c('router-view') }
                        },
                        children: [
                            {
                                path: 'list',
                                name: 'poll_list',
                                meta: {
                                    requires_auth: true,
                                },
                                component: EventPollListView
                            }
                        ]
                    },
                    {
                        path: 'list',
                        name: 'event_list',
                        meta: {
                            requires_auth: true,
                            required_permissions: ['op.admin.event.view']
                        },
                        component: EventListView
                    },
                    {
                        path: 'manage',
                        name: 'event_manage',
                        meta: {
                            requires_auth: true,
                            required_permissions: ['op.admin.event.view']
                        },
                        component: EventManageView
                    }
                ]
            },
            {
                path: 'contact',
                meta: { requires_auth: true },
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '/',
                        redirect: 'contact_list'
                    },
                    {
                        path: 'list',
                        name: 'contact_list',
                        meta: {
                            requires_auth: true,
                            required_permissions: ['op.admin.contact.view']
                        },
                        component: ContactListView
                    },
                    {
                        path: 'group',
                        name: 'contact_group',
                        meta: {
                          requires_auth: true,
                          required_permissions: ['op.admin.contact.group.view']
                        },
                        component: ContactGroupView
                  }
                ]
            },
            {
                path: 'team',
                meta: { requires_auth: true },
                component: {
                    render (c) { return c('router-view')}
                },
                children: [
                    {
                        path: '/',
                        redirect: 'team_list'
                    },
                    {
                        path: 'list',
                        name: 'team_list',
                        meta: {
                            requires_auth: true,
                            required_permissions: []
                        },
                        component: TeamListView
                    }
                ]
            },
            {
                path: 'user',
                meta: {requires_auth: true},
                component: {
                    render (c) { return c('router-view') }
                },
                children: [
                    {
                        path: '/',
                        redirect: 'account_details'
                    },
                    {
                        path: 'details',
                        name: 'account_details',
                        meta: { requires_auth: true },
                        component: UserDetailsView
                    }
                ]
            },
            // {
            //     path: 'agent',
            //     meta: {
            //         requires_auth: true,
            //         required_permissions: ['op.admin.agent.list']
            //     },
            //     component: {
            //         render (c) { return c('router-view') }
            //     },
            //     children: [
            //         {
            //             path: '/',
            //             redirect: 'agent_list'
            //         },
            //         {
            //             path: 'list',
            //             name: 'agent_list',
            //             meta: {
            //                 requires_auth: true,
            //                 required_permissions: ['op.admin.agent.list']
            //             },
            //             component: AgentListView
            //         }
            //     ]
            // },
            {
                path: 'admin',
                name: 'admin',
                meta: {
                    breadcrumb: true,
                    requires_auth: true
                },
                component: AdminView
            },
            {
                path: 'api',
                children: [
                    {
                        path: 'admin',
                        children: [
                            {
                                path: 'login_check',
                                name: 'api_login_check'
                            },
                            {
                                path: 'data_preload',
                                name: 'api_data_preload'
                            },
                            {
                                path: 'get_available_team',
                                name: 'api_get_available_team'
                            },
                            {
                                path: 'switch_account',
                                name: 'api_switch_account'
                            },
                            {
                                path: 'event',
                                children: [
                                    {
                                        path: 'list',
                                        name: 'api_event_list'
                                    },
                                    {
                                        path: 'get',
                                        name: 'api_event_get'
                                    },
                                    {
                                        path: 'save',
                                        name: 'api_event_update'
                                    },
                                    {
                                        path: 'delete',
                                        name: 'api_event_delete'
                                    },
                                    {
                                        path: 'attendee_list',
                                        name: 'api_event_attendee_list'
                                    },
                                    {
                                        path: 'export_attendee_list',
                                        name: 'api_event_export_attendee_list'
                                    },
                                    {
                                        path: 'guest_list',
                                        name: 'api_event_guest_list'
                                    },
                                    {
                                        path: 'poll',
                                        children: [
                                            {
                                                path: 'list',
                                                name: 'api_event_poll_list'
                                            },
                                            {
                                                path: 'save',
                                                name: 'api_event_poll_save'
                                            },
                                            {
                                                path: 'get_vote_option_details',
                                                name: 'api_event_poll_get_option_details'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'invitation',
                                        children: [
                                            {
                                                path: 'list',
                                                name: 'api_event_invitation_list'
                                            },
                                            {
                                                path: 'save',
                                                name: 'api_event_invitation_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_event_invitation_delete'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'deposit',
                                        children: [
                                            {
                                                path: 'get_transactions',
                                                name: 'api_get_payment_transactions'
                                            },
                                            {
                                                path: 'pay',
                                                name: 'api_add_payment'
                                            },
                                            {
                                                path: 'void',
                                                name: 'api_void_payment'
                                            },
                                            {
                                                path: 'get_received',
                                                name: 'api_get_payment_received'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'registration',
                                        children: [
                                            {
                                                path: 'list',
                                                name: 'api_registration_list'
                                            },
                                            {
                                                path: 'saveAttendees',
                                                name: 'api_registration_save_attendees'
                                            },
                                            {
                                                path: 'save',
                                                name: 'api_registration_save'
                                            },
                                            {
                                                path: 'cancel',
                                                name: 'api_registration_cancel'
                                            },
                                            {
                                                path: 'setIsPinnedToTop',
                                                name: 'api_registration_set_is_pinned_to_top'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'story',
                                        children: [
                                            {
                                                path: 'save',
                                                name: 'api_event_story_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_event_story_delete'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'media',
                                        children: [
                                            {
                                                path: 'save',
                                                name: 'api_event_media_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_event_media_delete'
                                            },
                                            {
                                                path: 'list',
                                                name: 'api_event_media_list'
                                            }
                                        ]
                                    },
                                    {
                                        path: 'activity',
                                        children: [
                                            {
                                                path: 'view',
                                                name: 'api_event_activity_view'
                                            },
                                            {
                                                path: 'save',
                                                name: 'api_event_activity_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_event_activity_delete'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: 'contact',
                                children: [
                                    {
                                        path: 'list',
                                        name: 'api_contact_list'
                                    },
                                    {
                                        path: 'save',
                                        name: 'api_contact_save'
                                    },
                                    {
                                        path: 'delete',
                                        name: 'api_contact_delete'
                                    },
                                    {
                                        path: 'import',
                                        name: 'api_contact_import'
                                    },
                                    {
                                        path: 'group',
                                        children: [
                                            {
                                                path: '/',
                                                redirect: 'api_contact_group_list'
                                            },
                                            {
                                                path: 'list',
                                                name: 'api_contact_group_list'
                                            },
                                            {
                                                path: 'name_list',
                                                name: 'api_contact_group_name_list'
                                            },
                                            {
                                                path: 'save',
                                                name: 'api_contact_group_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_contact_group_delete'
                                            },
                                            {
                                                path: 'delete_contact',
                                                name: 'api_contact_group_delete_contact'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: 'team',
                                children: [
                                    {
                                        path: 'list',
                                        name: 'api_team_list'
                                    },
                                    {
                                        path: 'save',
                                        name: 'api_team_save'
                                    },
                                    {
                                        path: 'delete',
                                        name: 'api_team_delete'
                                    },
                                    {
                                        path: 'kick',
                                        name: 'api_team_kick'
                                    },
                                    {
                                        path: 'leave',
                                        name: 'api_team_leave'
                                    },
                                    {
                                        path: 'invitation',
                                        children: [
                                            {
                                                path: 'save',
                                                name: 'api_team_invitation_save'
                                            },
                                            {
                                                path: 'delete',
                                                name: 'api_team_invitation_delete'
                                            },
                                            {
                                                path: 'accept',
                                                name: 'api_team_invitation_accept'
                                            },
                                            {
                                                path: 'reject',
                                                name: 'api_team_invitation_reject'
                                            },
                                            {
                                                path: 'get_by_key',
                                                name: 'api_team_invitation_get_by_key'
                                            },
                                            {
                                                path: 'accept_by_key',
                                                name: 'api_team_invitation_accept_by_key'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: 'file',
                                children: [
                                    {
                                        path: 'upload',
                                        name: 'api_file_upload'
                                    }
                                ]
                            },
                            {
                                path: 'user',
                                children: [
                                    {
                                        path: 'get_info',
                                        name: 'api_user_get_info'
                                    },
                                    {
                                        path: 'save',
                                        name: 'api_user_save'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'auth',
                        children: [
                            {
                                path: 'login',
                                name: 'api_login'
                            },
                            {
                                path: 'logout',
                                name: 'api_logout'
                            },
                            {
                                path: 'signup',
                                name: 'api_signup'
                            },
                            {
                                path: 'confirm',
                                name: 'api_confirm'
                            },
                            {
                                path: 'forget_password',
                                name: 'api_forget_password'
                            },
                            {
                                path: 'reset_password',
                                name: 'api_reset_password'
                            }
                        ]
                    },
                    {
                        path: 'event',
                        children: [
                            {
                                path: 'registration',
                                children: [
                                    {
                                        path: 'save',
                                        name: 'api_public_registration_save'
                                    },
                                    {
                                        path: 'retrieve',
                                        name: 'api_public_registration_retrieve'
                                    },
                                    {
                                        path: 'cancel',
                                        name: 'api_public_registration_cancel'
                                    },
                                    {
                                        path: 'decline',
                                        name: 'api_public_invitation_decline'
                                    }

                                ]
                            },
                            {
                                path: 'media',
                                children: [
                                    {
                                        path: 'get',
                                        name: 'api_public_event_media_get'
                                    }
                                ]
                            },
                            {
                                path: 'story',
                                children: [
                                    {
                                        path: 'get',
                                        name: 'api_public_event_story_get'
                                    }
                                ]
                            },
                            {
                                path: 'poll',
                                children: [
                                    {
                                        path: 'get',
                                        name: 'api_public_poll_get'
                                    },
                                    {
                                        path: 'submit',
                                        name: 'api_public_poll_submit'
                                    }
                                ]
                            },
                            {
                                path: 'get',
                                name: 'api_public_event_get'
                            },
                            {
                                path: 'search_invited_contact',
                                name: 'api_public_search_invited_contact'
                            }
                        ]
                    },
                    {
                        path: 'files',
                        children: [
                            {
                                path: 'upload',
                                name: 'api_public_file_upload'
                            }
                        ]
                    }
                ]
            },
            {
                path: 'unauthorized',
                name: 'error_401',
                component: UnauthorizedView
            },
            {   path: 'not_found',
                name: 'error_404',
                component: PageNotFoundView
            },
            {
                path: '*',
                redirect: { name: 'error_404' }
            }
        ]
    },
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach(async (to, from, next) => {

    let lang = to.params.lang;
    if(lang === ""){
        lang = store.state.lang;
    }

    store.dispatch('setLang', lang).then(async () => {

        if(!store.state.is_check_user_login){
            await store.dispatch('setIsCheckUserLogin', true);
        }

        if(store.state.is_user_logged_in){
            if(_.includes(['login', 'public_login'], to.name)){
                let redirect_url = store.state.redirect_url;
                console.log("get redirect url", redirect_url);
                if(redirect_url){
                    next(redirect_url);
                    store.dispatch('setRedirectUrl', "");
                } else {
                    next({
                        name: 'event_list',
                        params: {'lang': lang},
                        replace: true
                    });
                }

            }else {
                let required_permissions = to.meta.required_permissions;
                if(required_permissions && !AuthHelper.hasPermission(required_permissions)){
                    // todo: find a solution to redirect user to a page without changing the current url
                    // ref: https://github.com/vuejs/vue-router/issues/977
                    next({
                        name: 'error_401',
                        params: {'lang': lang},
                        replace: true
                    });
                }
            }
        } else {
            if(to.meta.requires_auth){

                store.dispatch('setRedirectUrl', window.location.pathname + window.location.search);

                next({
                    name: (store.state.login_type === 'public' ? 'public_login' : 'login'),
                    params: {'lang': lang},
                    replace: true
                });
            }
        }
        next();
    });
});

export default router;
